import { jsx as _jsx } from "react/jsx-runtime";
import { useQuery } from '@tanstack/react-query';
import { createContext, useContext, useMemo } from 'react';
import { AuthContext, ApiClientService, useApiClient } from 'libs.react_internal';
import { deduplicateEnvironments } from '../../helpers/environment.helpers';
export const EnvironmentsContext = createContext({
    isLoading: true,
    environments: [],
});
export const EnvironmentsProvider = ({ children }) => {
    const { entityId, user } = useContext(AuthContext);
    const identityId = user?.id;
    const momClient = useApiClient(ApiClientService.MOM);
    const fetchEnvironmentSites = async () => {
        if (!entityId || !identityId) {
            return [];
        }
        // TODO: retrieve remaining pages https://jira.devops.medable.com/browse/SSP-1780
        const response = await momClient.get(`/v1/entities/${entityId}/identities/${identityId}/environmentSites?page=1&limit=100`);
        const environmentSites = response?.data?.data || [];
        return deduplicateEnvironments(environmentSites);
    };
    const { data: environments = [], isLoading } = useQuery({
        queryKey: ['entities', entityId, 'identities', identityId, 'environmentSites'],
        queryFn: fetchEnvironmentSites,
        enabled: !!user && !!entityId && !!identityId,
    });
    const value = useMemo(() => ({
        isLoading,
        environments,
    }), [isLoading, environments]);
    return _jsx(EnvironmentsContext.Provider, { value: value, children: children });
};
